import AegisV2 from '@tencent/aegis-web-sdk-v2';
import { TApiError } from 'common/apiRequest/Request';
import { NO_COMPANY_ERROR } from 'common/constants/Constants';
import Utils from 'common/utils';
type TError = TApiError['response'] | { status: number };

class ResponseInterceptors {
  public onSuccess = (response: { data: any }): Promise<any> => {
    window.aegis?.report({
      type: 'api',
      level: AegisV2.logLevel.INFO,
      msg: Utils.aegisSuccessInfo(response),
    });

    return Promise.resolve(response.data);
  };

  public onError = (error: TApiError) => {
    const err = error.response || { status: 0 };

    if (err?.status >= 500) {
      window.aegis?.report({
        type: 'api',
        level: AegisV2.logLevel.AJAX_ERROR,
        msg: Utils.aegisErrorInfo(error),
      });
    }

    return this.handleError(err);
  };

  public handleError = (error: TError): any => {
    const status = _.get(error, 'status');
    switch (status) {
      case 412:
        this.handleNoCompany(NO_COMPANY_ERROR);
        return Promise.reject(error);
      default:
        return Promise.reject(error);
    }
  };

  // 自定义域名下，域名不可用则跳转到当前自定义域名的 IDP 错误页
  private handleNoCompany = (errCode: string) => {
    Utils.redirectToIdp(undefined, `/sso_login/error?errCode=${errCode}`);
  };
}

export default new ResponseInterceptors();
